import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable({
providedIn: 'root'
})
export class ComunicacaoComponentesService {
    private subject = new Subject<number>();

    enviaClick(numeroTab: number) {
        this.subject.next(numeroTab);
    }
    obtemClick(): Observable<number>{ 
        return this.subject.asObservable();
    }
}